import React from 'react';
import './Loading.css';

export function Loading(props) {
    return (
        <div>
            <div className="splashLogoContainer">
                <img src="/img/LisLogo.png" className="splashLogo" alt="Logo" />
            </div>
            <div className="splashSpinnerContainer">
                <i className="fas fa-spinner fa-spin"></i>
            </div>
        </div>

    );
}